import { render, staticRenderFns } from "./PressareaExhibitionImage.vue?vue&type=template&id=43407091&"
import script from "./PressareaExhibitionImage.vue?vue&type=script&lang=js&"
export * from "./PressareaExhibitionImage.vue?vue&type=script&lang=js&"
import style0 from "./PressareaExhibitionImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports